import React, { useState, useEffect, useCallback } from "react";
import { HeadingFour, MyDiv } from "../Common/Components";
import { Row, Col, Card, Spinner, Button } from "react-bootstrap";
import { TextField, MenuItem, Autocomplete } from "@mui/material";
import { DevelopmentTeam, GRDevelopmentTeam } from "../Common/Constants/staticjson";
import swal from "sweetalert2";
import moment from "moment";
import PropTypes from "prop-types";
import { postRequest, getRequest, patchRequest } from "../Common/api/apiService";

function ProjectTimeSheetForm({ handleClose, taskEditId }) {
  const [projectList, setProjects] = useState([]);
  const [ticketNumber, setTicketNumber] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [data, setData] = useState({
    tms_Task_Project_Obj: "",
    tms_Task_Desc: "",
    tms_Task_Brand: "",
    tms_Task_Department: "",
    tms_Task_Entry_Date: "",
    tms_Task_Worked_Hours: "",
  });

  const loadSpecificTimeSheet = useCallback(async () => {
  const editId = taskEditId?.id;
  if (!editId) return;

  const query = `fetch-emp-daily-task-to-edit/${editId}`;

  try {
    const response = await getRequest(query);

    const item = response?.data?.[0];
    if (!item) return;

    // Prepare clean mapped object
    const formattedData = {
      ...item,
      tms_Task_Entry_Date: item.tms_Task_Entry_Date
        ? moment(item.tms_Task_Entry_Date).format("YYYY-MM-DD")
        : "",
    };

    setData(formattedData);

    setTaskMode(
      item.tms_Task_Brand === "Service Project"
        ? "Project TimeSheet"
        : "Ticket TimeSheet"
    );

  } catch (error) {
    swal.fire({
      text: error.response?.data || "Something went wrong",
      icon: "error",
    });
  }
}, [taskEditId]);


  useEffect(() => {
    if (taskEditId?.id !== undefined && taskEditId?.id !== "") {
      loadSpecificTimeSheet();
    }
  }, [loadSpecificTimeSheet, taskEditId?.id]);

  const loadProjects = useCallback(async () => {
    const query = `fetchprojects`;
    try {
      const response = await postRequest(query, {}); // POST with empty body
      if (response?.data) {
        const uniqueProjects = response.data.filter(
          (project, index, self) => index === self.findIndex(t => t.pro_name === project.pro_name)
        );
        setProjects(uniqueProjects);
      }
    } catch (error) {
      swal.fire({
        text: error.response?.data || "Something went wrong while loading projects",
        icon: "error",
        type: "error",
      });
    }
  }, []);

  const loadAllTickets = useCallback(async () => {
    const query = `fetch-tickets-to-task`;
    try {
      const response = await getRequest(query);
      if (response?.data) {
        setTicketNumber(response.data);
      }
    } catch (error) {
      swal.fire({
        text: error.response?.data || "Something went wrong while loading tickets",
        icon: "error",
        type: "error",
      });
    }
  }, []);

  useEffect(() => {
    loadProjects();
    loadAllTickets();
  }, [loadProjects, loadAllTickets]);

  function handle(e) {
    const newdata = { ...data };
    newdata[e.target.id] = e.target.value;
    setData(newdata);
  }
  const handleChangeWhiteSpace = e => {
    const newdata = { ...data };
    newdata[e.target.id] = e.target.value;
    setData(newdata);
  };

  const handleFieldChange = event => {
    setData(data => ({
      ...data,
      [event.target.name]: event.target.type === "checkbox" ? event.target.checked : event.target.value,
    }));
  };

  
function submit(e) {
  e.preventDefault();
  setBtnLoading(true);

  const editId = taskEditId?.id;

  const endpoint = editId
    ? `update-emp-daily-task/${editId}`
    : `add-daily-task-details`;

  const requestFn = editId ? patchRequest : postRequest;

  requestFn(endpoint, data)
    .then(res => {
      if (res?.status === 200) {
        swal.fire({
          text: "Successfully Saved",
          icon: "success",
        });
        handleClose();
      }
    })
    .catch(error => {
      swal.fire({
        text: error.response?.data || "Something went wrong",
        icon: "error",
      });
    })
    .finally(() => {
      setBtnLoading(false);
    });
}

  const [taskMode, setTaskMode] = useState("Project TimeSheet");

  useEffect(() => {
    if (!taskEditId) {
      setTaskMode("Project TimeSheet");
      setData(prevData => ({
        ...prevData,
        tms_Task_Brand: "Service Project", // default brand for Project TimeSheet
      }));
    } else {
      // Editing existing task
      if (taskEditId.tms_Task_Brand === "Service Project") {
        setTaskMode("Project TimeSheet");
      } else {
        setTaskMode("Ticket TimeSheet");
      }
    }
  }, [taskEditId]);

  useEffect(() => {
    if (taskEditId) {
      if (taskEditId.tms_Task_Brand === "Service Project") {
        setTaskMode("Project TimeSheet"); 
      } else {
        setTaskMode("Ticket TimeSheet"); 
      }
    }
  }, [taskEditId]);

  const handleTaskModeChange = event => {
    setTaskMode(event.target.value);
    const newdata = {
      ...data,
      tms_Task_Brand: "Service Project",
    };
    setData(newdata);
  };

  return (
    <MyDiv className="DrawerRight">
      <MyDiv className="grid-margin general-form stretch-card">
        <Card md={12}>
          <Card.Header>
            <HeadingFour className="card-title">{taskEditId ? "Edit" : "Add"} TimeSheet</HeadingFour>
          </Card.Header>
          <Card.Body>
            <MyDiv className="DrawerForm">
              <form onSubmit={e => submit(e)}>
                <Row className="DrawerFormField">
                  <Col md={12}>
                    <TextField
                      select
                      variant="outlined"
                      disabled={taskEditId?.id}
                      label="Select Task Mode"
                      value={taskMode}
                      onChange={handleTaskModeChange}>
                      <MenuItem value="Project TimeSheet">Internal Project TimeSheet</MenuItem>
                      <MenuItem value="Ticket TimeSheet">GR Ticket TimeSheet</MenuItem>
                    </TextField>
                  </Col>
                  {taskMode === "Project TimeSheet" && (
                    <>
                      <Col md={12}>
                        <Autocomplete
                          id="tms_Task_Project_Obj"
                          options={projectList}
                          value={projectList.find(project => project._id === data.tms_Task_Project_Obj) || null}
                          getOptionLabel={option => option.pro_name}
                          onChange={(event, newValue) => {
                            setData(prevData => ({
                              ...prevData,
                              tms_Task_Project_Obj: newValue?._id,
                            }));
                          }}
                          renderInput={params => (
                            <TextField
                              required
                              {...params}
                              variant="outlined"
                              label="Search/Select Project"
                              placeholder="Search/Select"
                              onChange={event => {
                                if (event.target.value !== "" || event.target.value !== null) {
                                  console.log(event.target.value);
                                }
                              }}
                            />
                          )}
                        />
                      </Col>
                      <Col md={12}>
                        <TextField select required name="tms_Task_Department" id="tms_Task_Department" variant="outlined" label="Department" SelectProps={{ value: data.tms_Task_Department, onChange: handleFieldChange }}>
                          {DevelopmentTeam.map((Team, index) => (
                            <MenuItem key={index} value={Team.value}>
                              {Team.label}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Col>
                    </>
                  )}
                  {taskMode === "Ticket TimeSheet" && (
                    <>
                      <Col md={12}>
                        <Autocomplete
                          id="tms_Task_Project_Obj"
                          options={ticketNumber}
                          value={ticketNumber.find(project => project._id === data.tms_Task_Project_Obj) || null}
                          getOptionLabel={option => option.tms_Ticket_No}
                          onChange={(event, newValue) => {
                            setData(prevData => ({
                              ...prevData,
                              tms_Task_Project_Obj: newValue?._id,
                              tms_Task_Brand: newValue?.tms_Ticket_Brand,
                            }));
                          }}
                          renderInput={params => (
                            <TextField
                              required
                              {...params}
                              variant="outlined"
                              label="Search/Select Ticket"
                              placeholder="Search/Select"
                              onChange={event => {
                                if (event.target.value !== "" || event.target.value !== null) {
                                  console.log(event.target.value);
                                }
                              }}
                            />
                          )}
                        />
                      </Col>
                      <Col md={12}>
                        <TextField disabled required id="tms_Task_Brand" label="Ticket Brand" value={data.tms_Task_Brand ? data.tms_Task_Brand : ""} variant="outlined" />
                      </Col>
                      <Col md={12}>
                        <TextField select required name="tms_Task_Department" id="tms_Task_Department" variant="outlined" label="GR Department" SelectProps={{ value: data.tms_Task_Department, onChange: handleFieldChange }}>
                          {GRDevelopmentTeam.map((Team, index) => (
                            <MenuItem key={index} value={Team.value}>
                              {Team.label}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Col>
                    </>
                  )}
                  <Col md={12}>
                    <TextField required id="tms_Task_Desc" label="Task Description" multiline rows={4} value={data.tms_Task_Desc} variant="outlined" onChange={e => handleChangeWhiteSpace(e)} />
                  </Col>
                  <Col md={12}>
                    <TextField id="tms_Task_Entry_Date" required label="Worked Date" type="date" value={data.tms_Task_Entry_Date} sx={{ width: 220 }} onChange={e => handle(e)} InputLabelProps={{ shrink: true }} variant="outlined" />
                  </Col>
                  <Col md={12}>
                    <TextField required id="tms_Task_Worked_Hours" label="Worked Hours" value={data.tms_Task_Worked_Hours} variant="outlined" onChange={e => handleChangeWhiteSpace(e)} />
                  </Col>
                  <Col md={12} className="text-end">
                    {btnLoading ? (
                      <Button variant="primary" disabled className="mt-4 w-100">
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mx-2" />
                        Loading...
                      </Button>
                    ) : (
                      <button className="FormBtn">Submit</button>
                    )}
                  </Col>
                </Row>
              </form>
            </MyDiv>
          </Card.Body>
        </Card>
      </MyDiv>
    </MyDiv>
  );
}
export default ProjectTimeSheetForm;

ProjectTimeSheetForm.propTypes = {
  handleClose: PropTypes.any,
  taskEditId: PropTypes.any,
};
